export default {
  // Options.jsx
  items_per_page: '/ síðu',
  label_items_per_page: 'Items / page',
  jump_to: 'Síða',
  jump_to_confirm: 'staðfest',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Fyrri síða',
  next_page: 'Næsta síða',
  prev_5: 'Til baka 5 síður',
  next_5: 'Áfram 5 síður',
  prev_3: 'Til baka 3 síður',
  next_3: 'Áfram 3 síður',
};
